module.exports = __webpack_public_path__ + "static/car9-31af14dfd7d23cabbacf5ad2a1b16ad8.png";